// tokenTimer.js
let tokenRefreshTimer = null;

export const startTokenTimer = (callback) => {
  // Clear existing timer if any
  if (tokenRefreshTimer) clearInterval(tokenRefreshTimer);

  // Start a new timer
  tokenRefreshTimer = setInterval(() => {
    console.log("Refreshing Salesforce token after 25 mins...");
    callback();
  }, 25 * 60 * 1000);
};

export const clearTokenTimer = () => {
  if (tokenRefreshTimer) {
    clearInterval(tokenRefreshTimer);
    tokenRefreshTimer = null;
    console.log("Token refresh timer cleared");
  }
};
